<template>
  <v-dialog
    v-model="dialog"
    persistent
    :max-width="options.width"
    @keydown.esc="cancel"
    v-bind:style="{zIndex: options.zIndex}"
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <baseModal>

      <v-btn
        slot="positive-button"
        dark text class="orange--text text-h6 font-weight-bold" @click.native="agree">등록</v-btn>

      <v-btn
        v-if="index > -1"
        slot="func-button"
        dark text class="pink--text text--lighten-2 text-h6" @click.native="remove">삭제</v-btn>

      <v-btn
        slot="negative-button"
        dark text class="white--text subheading" @click.native="cancel">취소</v-btn>

      <v-btn
        slot="star-area"
        icon
        @click.native="form.isStar = !form.isStar"
      >
        <v-icon
          v-if="!form.isStar"
          color="grey lighten-1"
        >
          mdi-star-outline
        </v-icon>
        <v-icon
          v-else
          color="yellow"
        >
          mdi-star
        </v-icon>
      </v-btn>

      <v-toolbar-title
        slot="title-area"
        class="white--text">{{ title }}</v-toolbar-title>

      <!-- 중요: 상단 툴바 타이틀을 고정시키기 위해 아래처럼 v-card에 max-height를 주면 된다 -->
      <!-- <v-card
        slot="content"
        tile
        elevation="0"
        class="overflow-y-auto py-2 px-3"
        :max-height="options.height"
      >
        <v-card-text> -->

      <!-- 상단 툴바를 고정시키지 않으려면 아래 주석을 푼다. 하단의 태그 끝에도 주석을 풀어야 한다. -->
      <v-card-text
        slot="content"
        class="pb-0"
      >
        <v-container fluid class="pb-0"><!-- 여기까지 적용 -->

          <v-row no-gutters>

            <v-col v-show="index > -1" cols="12" xs="12">
              <v-alert type="info" dense text class="text-body-2">
                환급,취소가 있는 경우, 금액 등을 수정/삭제하여 실지출비용 형태로 관리하십시오.
              </v-alert>
            </v-col>
            <v-col cols="12" xs="12">
              <v-text-field
                v-model.trim="article.teamName"
                label="담당부서"
                readonly
              >
                <template v-slot:prepend>
                  <v-icon
                    :color="article.teamColorOrigin"
                  >mdi-account-group</v-icon>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="4" class="pt-0">
              <v-select
                v-model="form.gubun1"
                :items="costCates"
                label="항목"
                dense
                menu-props="auto"
                class="pt-5"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="2">
              <v-tooltip bottom color="primary">
                <template v-slot:activator="{ on }">
                  <v-icon
                    small
                    v-on="on"
                    class="ml-3 pt-8"
                  >mdi-help-circle-outline</v-icon>
                </template>
                <span>비용항목의 추가,변경,삭제는 [관리자>카테고리관리]에서 가능합니다.</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" xs="12" sm="6">
              <v-text-field
                v-model.trim="form.str3"
                label="납부처"
                maxlength="30"
                counter="30"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="5">
              <v-menu
                ref="date1Selector"
                v-model="date1Selector"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model.trim="form.date1"
                    label="일자"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    style="width: 200px;"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.date1"
                  locale="ko"
                  @change="saveDate1"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" xs="12" sm="7">
              <v-text-field
                ref="numStr2"
                v-model.trim="form.str2"
                v-validate="'required|max:13|is_not:0'"
                :error-messages="errors.collect('str2Cost')"
                data-vv-name="str2Cost"
                required
                label="*금액"
                maxlength="13"
                suffix="원"
                @keypress="preventComma"
              ></v-text-field>
            </v-col>
            <!-- <v-col cols="12" xs="12" class="py-2">
              <v-select
                v-model="relClientIds"
                :items="relClients"
                :menu-props="{ bottom: true, offsetY: true, maxHeight: '250' }"
                :label="cTitle2"
                multiple
                no-data-text="연계 의뢰인이 없습니다"
                dense
                style="font-size: 0.785rem !important"
                :readonly="rcReadOnly"
                @change="changeRelClient"
              >
                <template v-slot:selection="{ item }">
                  <v-chip small>
                    <span>{{ item.name }}</span>
                  </v-chip>
                </template>
              </v-select>
            </v-col> -->
            <!-- !![2021.5.25]소송/자문의 부담자는 단수로 변경됨 -->
            <template v-if="rcReadOnly">
              <v-col cols="12" xs="12" class="pt-0 pb-2">
                <v-text-field
                  v-model.trim="form.rInfo.name"
                  label="부담자"
                  readonly
                  prepend-icon="mdi-account-circle"
                  hide-details
                ></v-text-field>
              </v-col>
            </template>
            <template v-else>
              <v-col cols="12" xs="12" class="py-2">
                <v-select
                  v-model="form.rId"
                  :items="relClients"
                  :menu-props="{ bottom: true, offsetY: true, maxHeight: '250' }"
                  label="부담자"
                  dense
                  prepend-icon="mdi-account-circle"
                  style="font-size: 1rem !important"
                  @change="changeRelClient"
                  hide-details
                >
                  <template v-slot:selection="{ item }">
                    <span>{{ item.name }}</span>
                  </template>
                </v-select>
              </v-col>
            </template>
            <!-- 내용 -->
            <v-col cols="12" xs="12">
              <v-textarea
                ref="txt1"
                v-model="form.str1"
                outlined
                label="내용"
                placeholder="입력하세요"
                no-resize
                rows="5"
                counter="200"
                :rules="[rules.txtCounter]"
                @update:error="chkValidate = false"
                class="mt-5"
              ></v-textarea>
            </v-col>
            <v-col cols="12" xs="12">
              <v-alert
                border="left"
                outlined
                type="info"
                dense
                class="text-body-2"
              >
                {{ viewParentInfo }}
                <v-tooltip color="info" bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      small color="primary lighten-2"
                      @click="gotoDetail"
                      class="ml-1"
                    >mdi-launch</v-icon>
                  </template>
                  <span>바로가기</span>
                </v-tooltip>
              </v-alert>
            </v-col>
            <!-- <v-col cols="12" v-show="index > -1" class="py-0">
              <v-card
                tile
                elevation="0"
                class="ma-0 pa-0"
              >
                <v-card-actions class="ma-0 pa-0">
                  <v-btn small text icon color="primary" disabled>
                    <v-icon small>print</v-icon>
                  </v-btn>
                  <v-btn small text icon color="primary" disabled>
                    <v-icon small>get_app</v-icon>
                  </v-btn>
                  <v-btn small text icon color="primary" disabled>
                    <v-icon small>phone_iphone</v-icon>
                  </v-btn>
                  <v-btn small text icon color="primary" disabled>
                    <v-icon small>local_post_office</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <span class="text-caption mr-2">{{ viewWname }}</span><span class="text-caption">{{ viewUpdatedAt }}</span>
                </v-card-actions>
              </v-card>
            </v-col> -->
            <v-col cols="12">
              <div class="mb-8"></div>
            </v-col>

          </v-row>

        <!-- 상단 타이틀 고정을 풀때 사용 -->
        </v-container>
      </v-card-text>

        <!-- 상단 타이틀 고정시 사용 -->
        <!-- </v-card-text>
      </v-card> -->

    </baseModal>

  </v-dialog>
</template>

<script>
import ko from 'vee-validate/dist/locale/ko'
import baseModal from '@/components/common/BaseModal' // 기본 다이얼로그

// 구분: filters
import numberFormat from '@/filters/numberFormat' // number-format
import numberFormatR from '@/filters/numberFormatR' // reverse number-format
import preventComma from '@/filters/preventComma' // keypress event 에서 쉼표막기
import strDateFormat from '@/filters/strDateFormat'
import isNumber from '@/filters/isNumber'

export default {
  components: {
    baseModal
  },

  props: [ 'article' ],

  $_veeValidate: {
    validator: 'new'
  },

  data: () => ({
    // 구분: 다이얼로그 관련
    dialog: false,
    resolve: null,
    reject: null,
    title: null,
    options: {
      fixedClient: false, // 중요:[2021.7.7] 고정된 의뢰인이 넘어오는지 여부를 옵션에 붙였다.
      color: 'primary',
      width: 770,
      height: 750,
      zIndex: 200
    },
    // 구분: Form 관련
    form: {
      id: 0,
      // relClientInfos: [], // 연계 의뢰인 정보 배열
      teamId: 1, // 기본팀이 초기값
      type: 23, // 비용
      depth: 2,
      pId: 0,
      pType: 1, // 소송(1), 자문(2)
      pInfo: '', // 정보위치(부모의 정보 중 보여줄 정보 이름)
      rId: 0,
      rType: 3, // 인명부
      rInfo: '',
      isStar: 0,
      isSchedule: 1,
      subtype: 1, // 등록을 제외한 업무는 1로 세팅(등록은 자동입력데이터임)
      gubun1: '', // 카테고리관리 > 비용항목에서 가져온다(이자리는 항상 카테고리)
      gubun2: '지출', // 유형 - '지출'로 픽스
      gubun3: '청구함', // 유형에 따른 구분 - '청구함'으로 픽스
      status: 2, // 관리상태 - '완료'로 픽스
      date1: '', // 일자
      str1: '', // 내용
      str2: '0', // 금액
      str3: '', // 납부처/환급처
      parentInfo: '' // [2021.3.23] 부모정보 문자열
    },
    // 구분: 중요: 연계의뢰인 리스트
    relClients: [
      { text: '청구안함', value: 0, name: '청구안함' }
    ],
    // 구분: 중요: 선택한 연계 의뢰인 배열
    // relClientIds: [ 0 ],
    // 구분: 중요: 업무대상자 셀렉트 읽기모드 여부 - 2021.5.24 이후 필요없어짐
    rcReadOnly: false,
    // 구분: 항목(gubun1) - 카테고리
    costCates: [],
    // cTitle2: '부담자', // 비용부담자/반환대상자 제목 변환
    // 구분: 수정 인덱스
    index: -1,
    // 구분: _veeValidate dictionary
    dictionary: {
      messages: ko.messages,
      attributes: {
        str2Cost: '금액'
      }
    },
    // 구분: 입력 검증
    rules: {
      txtCounter: v => v.length <= 200 || '200자 이하의 내용을 입력해 주세요'
    },
    // 구분: txt1 유효성 체크
    chkValidate: true,
    // 구분: 일자, 발행일
    date1Selector: false, // 일자 셀렉터
    // 구분: 수정시 처리자와 최종업데이트 정보
    viewWname: '',
    viewUpdatedAt: '',
    // 구분: 바로가기에 보여줄 부모 정보
    viewParentInfo: ''
  }),

  mounted () {
    this.$validator.localize('ko', this.dictionary)

    // !!항목 - 카테고리에서 가져와 매칭한다.
    this.setCates('12').then(({ cates }) => {
      if (cates && cates.length > 0) {
        this.costCates = cates.map(c => c.gubun1)
        this.form.gubun1 = this.costCates[0] // 초기값 지정
      } else {
        this.costCates = []
      }
    })
  },

  watch: {
    // !![2021.3.15] 수정
    'form.str2': {
      handler: function (val, oldVal) {
        if (!val) {
          this.form.str2 = '0'
          this.$refs.numStr2.lazyValue = '0'
        } else {
          if (val.length > 1 && val[0] === '0') {
            this.form.str2 = val.replace(/(^0+)/, '')
          }
          this.form.str2 = numberFormatR(this.form.str2)
          this.form.str2 = numberFormat(this.form.str2)

          if (!/^\d{1,3}(,\d{3})*$/gi.test(this.form.str2)) {
            this.form.str2 = oldVal
            this.$refs.numStr2.lazyValue = oldVal
          }
        }
      }
    }
  },

  methods: {
    isNumber, // 숫자만 인지 체크하는 필터
    numberFormat,
    numberFormatR,
    preventComma,
    dummy () {
      console.log('dummy test')
    },
    sbpop (e) {
      // 서버에서 수신받은 에러는 router 에서 가로채기 하므로 띄우지 않도록 if (!e.response) 를 검사한다.
      if (!e.response) this.$store.commit('SB_POP', { msg: e.message })
    },
    // !!중요: 재귀적으로 부모의 $refs 를 탐색하여 target 객체를 찾아 리턴한다.
    // 주로 팝업을 검색하는데 사용!
    async findParentRefs (parent, target) {
      try {
        for (let key in parent.$refs) {
          if (key === target) { // 찾은경우
            return parent.$refs[key]
          }
        }
        // 못찾은 경우 - 부모가 또 있으면 올라간다.
        if (parent.$parent) {
          return await this.findParentRefs(parent.$parent, target)
        } else {
          return null // 못찾으면 null 리턴
        }
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 초기화
    async initDialog () {
      // validation 초기화
      this.$validator.reset()

      this.form.id = 0
      // this.form.relClientInfos = [] // !! 연계의뢰인 정보 배열
      this.form.teamId = 1 // 기본팀을 기본값으로
      this.form.pId = 0 // 부모 아이디
      this.form.pType = 1 // 부모 타입: 소송(1), 자문(2)
      this.form.pInfo = '' // 정보위치(부모의 정보 중 보여줄 정보 이름)
      this.form.rId = 0
      this.form.rType = 3 // 업무대상자는 인명부(3)의 의뢰인
      this.form.rInfo = ''
      this.form.gubun1 = this.costCates[0] // 항목 - 카테고리에서 실시간 매칭
      this.form.gubun2 = '지출' // 유형
      this.form.gubun3 = '청구함' // 유형에 따른 구분 - 중요: '청구함'으로 픽스
      this.form.status = 2 // 관리상태 - 중요: '완료'로 픽스
      this.form.isStar = 0
      this.form.isSchedule = 1 // 일정표시여부
      this.form.date1 = this.$moment().format('YYYY-MM-DD') // 일시 초기값(오늘)
      this.form.str1 = '' // 내용
      this.form.str2 = '0' // 금액
      this.form.str3 = '' // 납부처/환급처
      this.form.subtype = 1 // 이걸 해줘야 한다!
      this.form.parentInfo = ''

      // !! 연계의뢰인 셀렉트 초기화
      this.relClients = [
        { text: '청구안함', value: 0, name: '청구안함' }
      ]
      // !! 연계의뢰인 선택 초기화
      // this.relClientIds = [ 0 ]
      // !! 셀렉트 읽기모드 여부 - 2021.5.24 이후 필요없어짐
      this.rcReadOnly = false

      this.index = -1 // 수정용 인덱스 초기화

      this.options.fixedClient = false // 중요: 고정의뢰인여부를 초기화 해야한다.
    },
    async open (title, options, index = -1, obj = {}, relClients) {
      try {
        await this.initDialog() // 초기화 - [2021.7.7] 순서변경.. 초기화를 맨 처음에

        this.dialog = true
        this.title = title
        this.options = Object.assign(this.options, options)

        // console.log(this.article) // !! props 로 넘어온 부모 데이터

        // !! 연계 의뢰인 셀렉트 매칭
        // 중요:[2021.7.7] 고정된 의뢰인이 넘어온 경우 처리 추가
        if (this.options.fixedClient) {
          // 옵션으로 고정의뢰인이 왔다는 표기가 넘어오면 relClients 에는 1개의 의뢰인 정보만 들어있는 배열이다.
          this.relClients = relClients
          this.form.rId = relClients[0].value // 부담자 아이디
          this.form.rInfo = relClients[0].rInfo // 부담자 객체
        } else {
          // 고정된 의뢰인이 아니면 연계의뢰인 배열에 넘어온 넘들을 추가한다.
          this.relClients.push(...relClients)
        }

        // !! 아래 3개는 부모로부터 넘겨받은 데이터로 매칭하자(뭐 이렇게 하지 않아도 되는데)
        this.form.teamId = this.article.teamId
        this.form.pId = this.article.id
        this.form.pType = this.article.type1

        // !! 소송/자문에 따른 부모 정보 - 2021.3.19 수정
        if (this.article.type1 === 1) { // 소송인 경우
          this.viewParentInfo = `${this.article.courtName} ${this.article.caseNum}${this.article.manageNum ? `/${this.article.manageNum}` : ''}`
          this.form.parentInfo = this.article.caseNum
        } else { // 자문
          this.viewParentInfo = `${this.article.manageNum}`
          this.form.parentInfo = this.article.manageNum
        }

        // 중요:[2021.3.19] 부모정보의 객체를 문자열로 변환해서 this.form.pInfo 에 담는다.
        this.form.pInfo = JSON.stringify(this.article.pInfo)

        // 참고: 편집 모드인 경우 - 넘어온 객체를 this.form 에 복사
        if (index > -1) {
          // console.log(obj) // 파라미터로 넘어온 업무
          this.index = index

          this.form.id = obj.id

          // !! 업무대상자인 인명부(의뢰인) 정보가 있는 경우 처리
          if (obj.rId) {
            // console.log(obj.rId)
            // !! rId, rInfo 를 채운다
            this.form.rId = obj.rId
            this.form.rInfo = obj.rInfo // 부담자명

            // !![2021.5.25] 복수가 아니라서 아래는 없어짐
            // // 1) 셀렉트 고정
            // this.relClients = [
            //   { text: obj.rInfo, value: obj.rId, name: obj.rInfo }
            // ]
            // // 2) 셀렉트 선택 & readOnly
            // this.relClientIds = [ obj.rId ]
            // this.rcReadOnly = true
            // // 3) 폼의 연계의뢰인 정보 배열은 초기화 시키고
            // this.form.relClientInfos = []
            // // 4) 폼의 정보 고정
            // this.form.relClientInfos.push({ id: obj.rId, name: obj.rInfo })

            // !!중요: 하지만 부담자가 있으면 고정시킨다
            this.rcReadOnly = true
          }

          this.form.gubun1 = obj.gubun1
          this.form.gubun2 = obj.gubun2
          this.form.gubun3 = obj.gubun3

          this.form.status = obj.status
          this.form.subtype = obj.subtype
          this.form.isStar = obj.isStar

          this.form.str1 = obj.str1 // 내용
          this.form.str2 = obj.str2.toString() // !! 계산된 금액(수정시 정수값을 문자열로 변환해야 한다.)
          this.form.str3 = obj.str3 // 납부처/환급처

          this.form.date1 = obj.date1.substr(0, 10) // 일자 처리

          // 참고: 편집일때는 처리자와 업데이트 일자를 보여준다.
          this.viewWname = obj.wname
          this.viewUpdatedAt = strDateFormat(obj.updatedAt) // 필터로 쓰진 않고 함수로 사용
        }

        // 프로미스를 리턴하면서 resolve를 매칭하고있다.
        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 등록
    async agree () {
      try {
        // 참고: 입력값 검증
        let isValidate = await this.$validator.validateAll()
        if (!isValidate) throw new Error('입력값을 확인해 주세요')

        // 중요: textarea 의 글자수가 200 이하로 조정되면 여기서 체크해서 처리한다.
        if (this.rules.txtCounter(this.$refs.txt1.value) === true) {
          this.chkValidate = true
        }
        if (!this.chkValidate) throw new Error('저장할 수 없습니다. 내용 항목의 글자수를 줄여주세요.')

        // !! 한번더 - 금액에 대해 숫자만 남긴다
        // this.form.str2 = this.form.str2.replace(/[^0-9]/g, '')

        // 일자 처리 - 시분초를 붙여준다.
        this.form.date1 = `${this.form.date1.substr(0, 10)} 00:18:01`

        // 중요:[2021.7.7] 부담자(의뢰인객체)가 선택된 경우 JSON 문자열로 변환해서 보낸다.
        if (this.form.rInfo && typeof this.form.rInfo === 'object') {
          this.form.rInfo = JSON.stringify(this.form.rInfo)
        }

        // 리턴객체
        let resolve = {
          isDeleted: false, // 부모가 삭제되었는지 여부
          teamError: false, // 부모의 팀에러
          chInfo: null, // 부모의 에러에 대한 메시지
          rsMsg: '' // resolve 메시지
        }

        // !! DB 입력 처리 (등록/수정 동일하게 처리)
        const { data } = await this.$axios.post(`lawork/case/setRelCost`, this.form)
        if (!data.success) throw new Error(`오류가 발생하였습니다: ${data.message}`)
        // 리턴값으로 resolve 채우기
        resolve.isDeleted = data.isDeleted
        resolve.teamError = data.teamError
        resolve.chInfo = data.chInfo
        resolve.rsMsg = 'success'

        // 등록 후
        await this.initDialog()
        this.resolve(resolve) // this.resolve(true)
        this.dialog = false
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 취소
    async cancel () {
      try {
        await this.initDialog() // 초기화
        this.resolve(false) // reject() 가 아니라 resolve(false)로 던져야 한다.
        this.dialog = false
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 삭제
    async remove () {
      try {
        if (!this.form.id) throw new Error(`잘못된 요청입니다.`)

        // 중요: 재귀적으로 부모의 $refs 에서 팝업 컴포넌트 객체를 얻는다.
        const target = 'confirmDialog'
        const pop = await this.findParentRefs(this.$parent, target)
        if (!pop) throw new Error('팝업창을 열 수 없습니다.')
        // 찾았으면 팝업을 연다
        const msg = `정말 삭제하시겠습니까?<br>삭제된 데이터는 복구되지 않습니다.`
        if (await pop.open('삭제', msg, { color: 'error', width: 400 })) {
          // 리턴객체
          let resolve = {
            isDeleted: false, // 부모가 삭제되었는지 여부
            teamError: false, // 부모의 팀에러
            chInfo: null, // 부모의 에러에 대한 메시지
            rsMsg: '' // resolve 메시지
          }
          // const { data } = await this.$axios.get(`lawork/case/deleteLwcommon/${this.form.id}`)
          // !!2021.2.17 - POST 방식으로 변경하며 필요 데이터만 파라미터로 넘긴다!
          const params = {
            id: this.form.id,
            teamId: this.form.teamId,
            type: this.form.type,
            depth: this.form.depth,
            pId: this.form.pId,
            pType: this.form.pType,
            pInfo: this.form.parentInfo // !![2021.3.23] parentInfo 를 보내는 것으로 변경함
          }
          const { data } = await this.$axios.post(`lawork/case/removeLwc`, params)
          if (!data.success) throw new Error(`오류가 발생하였습니다: ${data.message}`)
          // 리턴값으로 resolve 채우기
          resolve.isDeleted = data.isDeleted
          resolve.teamError = data.teamError
          resolve.chInfo = data.chInfo
          resolve.rsMsg = 'removed'

          await this.initDialog() // 초기화
          this.resolve(resolve) // this.resolve(true)
          this.dialog = false
        }
      } catch (e) {
        this.sbpop(e)
      }
    },
    // !![2021.5.24] 대대적인 수정 - 업무대상자 셀렉트 체인지 이벤트
    async changeRelClient () {
      try {
        // 주의:[2021.7.7] 부담자의 이름에서 의뢰인객체(rInfo)로 변경됨
        if (this.form.rId) {
          const rc = this.relClients.find(rc => rc.value === this.form.rId)
          // this.form.rInfo = rc.name
          this.form.rInfo = rc.rInfo // 부담자는 의뢰인 객체
        } else {
          this.form.rInfo = ''
        }

        // const index = this.relClientIds.indexOf(0)
        // if (index === 0) {
        //   // 구분안함(0) 이 첫번째에 있으면 구분안함을 지워야 한다.
        //   this.relClientIds.splice(index, 1)
        // } else if (index >= 0) {
        //   // 구분안함(0) 이 중간에 들어오면 모두 지우고 0을 넣어야 한다.
        //   this.relClientIds = [ 0 ]
        // }

        // // 선택된게 아무것도 없으면 구분안함(0)을 선택한다.
        // if (this.relClientIds.length === 0) {
        //   this.relClientIds = [ 0 ]
        // }

        // // 폼의 연계의뢰인 정보 배열은 초기화 시키고
        // this.form.relClientInfos = []

        // // 구분안함이 아닌 항목이 선택되었으면. 첫번째 항목의 값은 1이 아니다.
        // if (this.relClientIds[0] > 0) {
        //   for (let value of this.relClientIds) {
        //     // 선택된 의뢰인을 this.relClients 에서 찾아서 this.form.relClientInfos 에 넣는다
        //     const selected = this.relClients.find(rc => rc.value === value)
        //     this.form.relClientInfos.push({ id: selected.value, name: selected.name })
        //   }
        // }
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 카테고리 패칭 함수 - 공통함수로 빼기 난해
    async setCates (type) {
      try {
        const { data } = await this.$axios.get(`admin/cate/getType/${type}`)
        if (!data.success) throw new Error(`list error: ${data.message}`)
        return { cates: data.cates }
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 일자 셀렉트 선택시 저장 함수
    async saveDate1 (date) {
      this.$refs.date1Selector.save(date)
    },
    // 소송/자문 상세페이지 바로가기
    async gotoDetail () {
      this.dialog = false
      if (this.article.type1 === 1) { // 소송인 경우
        // !! 현재 경로가 case 디렉토리가 아닌 경우만 case/ 로 이동시킨다
        if (!(this.$router.history.current.path.indexOf('case') !== -1)) {
          this.$router.push(`/case/${this.article.id}`)
        }
      } else { // 자문일때
        // !! 현재 경로가 advice 디렉토리가 아닌 경우만 advice/ 로 이동시킨다
        if (!(this.$router.history.current.path.indexOf('advice') !== -1)) {
          this.$router.push(`/advice/${this.article.id}`)
        }
      }
    }
  }
}
</script>
